import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/filter';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {ManageOrderService} from '../manage-order.service';
import {Customer, Order} from '../app-models/models';

@Component({
  selector: 'app-manage-order',
  templateUrl: './manage-order.component.html',
  styleUrls: ['./manage-order.component.css'],
  providers: [ManageOrderService]
})
export class ManageOrderComponent implements OnInit {
  private id: string;
  private compObj: Order;
  private actionMessage: string;
  private actionStatus = true;
  private isAdmin = false;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ManageOrderService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.isAdmin = IsAdmin.call(this);
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
      });
    this.componentService.getData(this.id).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.compObj = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.editData(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Save Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

  onSecondary(event) {
    this.actionMessage = null;
    this.router.navigate(['/create/customer'], { queryParams: { orderId: this.compObj.id } });
  }

  onDelete() {
    this.actionMessage = null;
    this.componentService.deleteItem(this.compObj.id).then(this.deleteSuccess.bind(this))
      .catch(this.deleteFail.bind(this));
  }

  deleteFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Delete Failed!';
    }
  }

  deleteSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }
}




// WEBPACK FOOTER //
// ./src/app/manage-order/manage-order.component.ts